// /admin/ads → תהליך הרשמה: the WhatsApp message templates (lib/waTemplates.js) — what
// each is for and Meta's review status. Templates are the only way to write to someone
// more than 24h after their last message; a template works only once APPROVED.
import {FC, useEffect, useState} from 'react'
import {getWaTemplates, submitWaTemplates, WaTemplateRow} from './_requests'

const BADGE: Record<string, string> = {
  APPROVED: 'badge-light-success',
  PENDING: 'badge-light-warning',
  IN_APPEAL: 'badge-light-warning',
  REJECTED: 'badge-light-danger',
  PAUSED: 'badge-light-danger',
  DISABLED: 'badge-light-danger',
  NOT_SUBMITTED: 'badge-light',
}
const LABEL: Record<string, string> = {
  APPROVED: 'אושרה',
  PENDING: 'בבדיקה במטא',
  IN_APPEAL: 'בערעור',
  REJECTED: 'נדחתה',
  PAUSED: 'מושהית',
  DISABLED: 'מושבתת',
  NOT_SUBMITTED: 'לא נשלחה',
}

const WaTemplates: FC = () => {
  const [rows, setRows] = useState<WaTemplateRow[] | null>(null)
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const load = () =>
    getWaTemplates()
      .then(({data}) => setRows(data.templates))
      .catch((e) => setErr(e?.response?.data?.error || e.message))
  useEffect(() => {
    load()
  }, [])
  const submit = async () => {
    setBusy(true)
    setErr('')
    try {
      await submitWaTemplates()
      await load()
    } catch (e: any) {
      setErr(e?.response?.data?.error || e.message)
    } finally {
      setBusy(false)
    }
  }
  const missing = (rows || []).some((r) => r.status === 'NOT_SUBMITTED')
  return (
    <div className='card card-bordered mb-4'>
      <div className='card-body p-5'>
        <div className='d-flex align-items-center justify-content-between mb-2'>
          <h4 className='fw-bold m-0'>תבניות וואטסאפ (לשליחה אחרי 24 שעות)</h4>
          <div className='d-flex gap-2'>
            <button className='btn btn-sm btn-light' onClick={load}>
              רענון
            </button>
            {missing && (
              <button className='btn btn-sm btn-primary' disabled={busy} onClick={submit}>
                {busy ? 'שולח…' : 'שליחה לאישור מטא'}
              </button>
            )}
          </div>
        </div>
        <div className='text-muted fs-7 mb-3'>
          וואטסאפ מרשה הודעה חופשית רק עד 24 שעות מההודעה האחרונה של הלקוח. אחרי זה נשלחת רק תבנית
          שמטא אישרה (בדרך כלל תוך דקות עד יום).
        </div>
        {err && <div className='alert alert-danger py-2'>{err}</div>}
        {!rows ? (
          <div className='text-muted'>טוען…</div>
        ) : (
          <table className='table table-sm table-row-bordered align-middle fs-7 mb-0'>
            <tbody>
              {rows.map((r) => (
                <tr key={r.name}>
                  <td dir='ltr' className='text-start' style={{width: 190}}>
                    <code>{r.name}</code>
                  </td>
                  <td>{r.use}</td>
                  <td style={{width: 120}}>
                    <span className={`badge ${BADGE[r.status] || 'badge-light'}`}>
                      {LABEL[r.status] || r.status}
                    </span>
                    {r.rejected_reason && (
                      <div className='text-danger fs-9 mt-1'>{r.rejected_reason}</div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default WaTemplates
